// ゲームカードの操作・表示に関する端末ローカル設定（localStorage保存・サーバー非同期）。
// アカウント同期する設定（並び順 personalize 等）とは別系統。ここはこの端末だけの好み。
import type { CardSize, CardRadius } from '../components/library/ViewSettingsDialog';

// localStorage キー（既存ユーザーの保存値を保つため文字列は変更しないこと）
const KEYS = {
  rightClickMenu: 'gamecard_right_click_menu',
  cardSize: 'library_card_size',
  cardUi: 'library_card_ui',
  cardRadius: 'library_card_radius',
  cardTitle: 'library_card_title',
} as const;

const read = (key: string): string | null =>
  typeof window !== 'undefined' ? localStorage.getItem(key) : null;

const write = (key: string, value: string): void => {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* localStorage 利用不可時は黙って無視 */
  }
};

// --- カード右クリックでステータスメニューを開く（PC）。未設定時はON ---
export const isRightClickMenuEnabled = (): boolean => read(KEYS.rightClickMenu) !== 'off';
export const setRightClickMenuEnabled = (on: boolean): void =>
  write(KEYS.rightClickMenu, on ? 'on' : 'off');

// --- カードサイズ（標準/正方形/横長）。未設定時は standard ---
export const readCardSize = (): CardSize => {
  const v = read(KEYS.cardSize);
  return v === 'square' || v === 'landscape' ? v : 'standard';
};
export const writeCardSize = (v: CardSize): void => write(KEYS.cardSize, v);

// --- カードUIオーバーレイ表示。未設定時は表示(on) ---
export const readUiVisible = (): boolean => read(KEYS.cardUi) !== 'off';
export const writeUiVisible = (visible: boolean): void => write(KEYS.cardUi, visible ? 'on' : 'off');

// --- カードの角（角/角丸）。未設定時は sharp ---
// 旧 'standard'(4px) は廃止したので sharp へ読み替える。
// localStorage に残った値でも落ちないよう、rounded 以外はすべて sharp に倒す。
export const readCardRadius = (): CardRadius =>
  read(KEYS.cardRadius) === 'rounded' ? 'rounded' : 'sharp';
export const writeCardRadius = (v: CardRadius): void => write(KEYS.cardRadius, v);

// --- カードタイトル表示。未設定時は表示(on) ---
export const readTitleVisible = (): boolean => read(KEYS.cardTitle) !== 'off';
export const writeTitleVisible = (visible: boolean): void =>
  write(KEYS.cardTitle, visible ? 'on' : 'off');
